require('./utilidom');
require('./sound');
require('./loader');
require('./controller');
require('./scale');

require('./common.css');

window.onkeydown = function(e) {
	return !(e.keyCode === 32);
};



/** WEBPACK FOOTER **
 ** ./../../../../engine/public-src/common/common.js
 **/